import { render } from "./FormHeader.vue?vue&type=template&id=2830c862"
import script from "./FormHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./FormHeader.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"source/js/vue/components/sections/FormHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2830c862"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2830c862', __exports__)) {
    api.reload('2830c862', __exports__)
  }
  
  module.hot.accept("./FormHeader.vue?vue&type=template&id=2830c862", () => {
    api.rerender('2830c862', render)
  })

}


export default __exports__